// hooks/useTableFilters.ts
import { useEffect, useState } from 'react';

export function ploTableFilters() {
  const [searchTerm, setSearchTerm] = useState('');
  const [caseYear, setCaseYear] = useState('');
  const [partySearch, setPartySearch] = useState('');
  const [selectedStatus, setSelectedStatus] = useState<string>('');
  const [adviceGivenDate, setAdviceGivenDate] = useState('');
  const [prosecutedStartDate, setProsecutedStartDate] = useState('');
  const [prosecutedEndDate, setProsecutedEndDate] = useState('');
  const [currentPage, setCurrentPage] = useState(1);

  const [debouncedSearch, setDebouncedSearch] = useState(searchTerm);
  const [debouncedCaseYear, setDebouncedCaseYear] = useState(caseYear);
  const [debouncedParty, setDebouncedParty] = useState(partySearch);

  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearch(searchTerm);
      setDebouncedCaseYear(caseYear);
      setDebouncedParty(partySearch);
    }, 300);
    return () => clearTimeout(timer);
  }, [searchTerm, caseYear, partySearch]);

  const handleClearFilters = () => {
    setSearchTerm('');
    setCaseYear('');
    setPartySearch('');
    setSelectedStatus('');
    setAdviceGivenDate('');
    setProsecutedStartDate('');
    setProsecutedEndDate('');
    setCurrentPage(1);
  };

  const hasActiveFilters = Boolean(
    searchTerm ||
      caseYear ||
      partySearch ||
      selectedStatus ||
      adviceGivenDate ||
      prosecutedStartDate ||
      prosecutedEndDate
  );

  return {
    searchTerm,
    setSearchTerm,
    caseYear,
    setCaseYear,
    partySearch,
    setPartySearch,
    selectedStatus,
    setSelectedStatus,
    adviceGivenDate,
    setAdviceGivenDate,
    prosecutedStartDate,
    setProsecutedStartDate,
    prosecutedEndDate,
    setProsecutedEndDate,
    currentPage,
    setCurrentPage,
    debouncedSearch,
    debouncedCaseYear,
    debouncedParty,
    handleClearFilters,
    hasActiveFilters,
  };
}